export var borderRadius01 = '2px';
export var borderRadius02 = '4px';
export var borderRadius04 = '8px';
export var borderRadiusPill = '16px';